import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import RankingSection from './components/RankingSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotRecommend />
        <CategoryNav />
        <LatestUpdates />
        <RankingSection />

        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              开启你的韩漫之旅
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto mb-6">
              妖精漫画作为免费阅读韩漫官网，是海量韩国漫画作品的集中入口。选择多样，导航清晰，助您轻松在浩瀚书海中找到所爱。
            </p>
            <a
              href="/category/all"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即探索全部作品
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}